import {
  PensioenIcon,
  VroegerIcon,
  KinderenIcon,
  PlannenIcon,
} from '@myfaro/ui-react';

import { ScenarioType } from '../core/types';

// TODO: find what type this needs
const scenarios: any = {
  retirementAge: {
    name: 'retirementAge',
    rightIcon: <PensioenIcon />,
    type: 'slider',
    rangeValues: { min: 63, max: 67, step: 1 },
    basicValue: 63,
  },
  yearsBeforeRetirementAge: {
    name: 'yearsBeforeRetirementAge',
    rightIcon: <VroegerIcon />,
    type: 'slider',
    rangeValues: { min: 0, max: 10, step: 1 },
    basicValue: 0,
  },
  desiredEndCapitalValue: {
    name: 'desiredEndCapitalValue',
    rightIcon: <KinderenIcon />,
    type: 'valueInput',
    rangeValues: { min: 0, max: 2000000, step: 1000 },
    basicValue: 0,
  },
};

export const getScenarios = (configScenarios: any) =>
  configScenarios.map((scenario: any) => scenarios[scenario]);
